"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBuildConfiguration = exports.getBuildConfiguration = void 0;
/**
 * @Author: Lucas Pires Camargo
 * @Date:   2023-03-02 17:02:02
 */

const getHostname = () => {
  return window.location.hostname;
};
const getPort = () => {
  const defaultBackendPort = 8000;
  // Use the port from the URL, or fall back to the default port if not available
  return process.env.BACKEND_PORT || defaultBackendPort;
};
var _build_config = null;
const _dummy_build_config = {
  project_name: "Untitled Application",
  project_version: "0.0.0",
  project_description: "An application without a set build configuration.",
  server_url_base: "http://".concat(getHostname(), ":").concat(getPort()),
  enableSSE: true
};
const getBuildConfiguration = () => {
  if (!_build_config) return _dummy_build_config;
  return _build_config;
};
exports.getBuildConfiguration = getBuildConfiguration;
const setBuildConfiguration = module => {
  if (_build_config) throw new Error("Build configuration can be set only once");

  // build new config dict from keys in dummy config
  let expected_fields = Object.keys(_dummy_build_config);
  let new_config = {};
  expected_fields.forEach(k => {
    if (!module.config.hasOwnProperty(k)) {
      throw new Error("Missing key in build config: " + k);
    }
    new_config[k] = module.config[k];
  });

  // seal the deal
  _build_config = new_config;
};
exports.setBuildConfiguration = setBuildConfiguration;